import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { SERVER_API_URL } from "src/app/app.constants";
import { CertificateRequestDto } from "../model/certificate-trade-details.model";

@Injectable({ providedIn: 'root' })
export class SpotShipmentDeclarationService {
    private resourceUrl = SERVER_API_URL + 'api/spot-certificate-requests';
    private failedRequestUrl = SERVER_API_URL + 'api/spot-failed-certificate-request';

    private underProcessRequestUrl = SERVER_API_URL + 'api/spot-under-process-certificate-request'
    private scopeUrl = SERVER_API_URL + 'api/spot-certificate-qutotation';

    constructor(private http: HttpClient) { }


    create(certificateDto: CertificateRequestDto,url) {

         url =  SERVER_API_URL +url;
        return this.http.post<any>(url, certificateDto, { observe: 'response' });
    }

    emailService(dto: any,url) {
        url =  this.resourceUrl + url;
       return this.http.post<any>(url, dto, { observe: 'response' });
   }
    saveFailedRequest(quotationBena){
        return this.http.post<any>(this.failedRequestUrl, quotationBena, { observe: 'response' });

    }

    saveFailedRequestWithoutLogin(quotationBena){
        let url = this.failedRequestUrl +'-without-login'
        return this.http.post<any>(url, quotationBena, { observe: 'response' });

    }

    saveScopeFilterRule(quotationBena){
        return this.http.post<any>(this.scopeUrl, quotationBena, { observe: 'response' });

    }

    saveUnderProcessRequest(quotationBena){
        return this.http.post<any>(this.underProcessRequestUrl, quotationBena, { observe: 'response' });

    }

    pushNotificationBreakedFlow(quotationBena){
        return this.http.post<any>(this.resourceUrl+'-push-notification-breaked-flow', quotationBena, { observe: 'response' });

    }
}